var map = {
	"./ActionableList": [
		91771,
		[
			22699,
			83096,
			88172,
			27045,
			74155,
			1354,
			47975,
			93814,
			46051,
			94927,
			51883,
			87140,
			12067,
			88007,
			9076,
			6531,
			65489,
			31041,
			90520,
			60005,
			95833,
			63428,
			2605,
			28360,
			28878,
			38273,
			34150,
			5246,
			87257,
			19181,
			23206,
			1506,
			36209,
			64753,
			44572,
			68400,
			45142,
			89986,
			61705,
			37485,
			41367,
			19874,
			17124
		]
	],
	"./ActionableList.jsx": [
		91771,
		[
			22699,
			83096,
			88172,
			27045,
			74155,
			1354,
			47975,
			93814,
			46051,
			94927,
			51883,
			87140,
			12067,
			88007,
			9076,
			6531,
			65489,
			31041,
			90520,
			60005,
			95833,
			63428,
			2605,
			28360,
			28878,
			38273,
			34150,
			5246,
			87257,
			19181,
			23206,
			1506,
			36209,
			64753,
			44572,
			68400,
			45142,
			89986,
			61705,
			37485,
			41367,
			19874,
			17124
		]
	],
	"./AdminCaseManagement": [
		57201,
		[
			93814,
			79600,
			274,
			57201
		]
	],
	"./AdminCaseManagement.jsx": [
		57201,
		[
			93814,
			79600,
			274,
			57201
		]
	],
	"./AdminDashboard": [
		34690,
		[
			22699,
			83096,
			88172,
			27045,
			47975,
			93814,
			46051,
			35645,
			96365,
			75693,
			32591,
			34690
		]
	],
	"./AdminDashboard.jsx": [
		34690,
		[
			22699,
			83096,
			88172,
			27045,
			47975,
			93814,
			46051,
			35645,
			96365,
			75693,
			32591,
			34690
		]
	],
	"./AgentLoginReportPage": [
		61720,
		[
			79345,
			61720
		]
	],
	"./AgentLoginReportPage.jsx": [
		61720,
		[
			79345,
			61720
		]
	],
	"./AgentPerformancePage": [
		88987,
		[
			59276,
			88987
		]
	],
	"./AgentPerformancePage.jsx": [
		88987,
		[
			59276,
			88987
		]
	],
	"./AgregarteSummaryCards": [
		73414,
		[
			73414
		]
	],
	"./AgregarteSummaryCards.jsx": [
		73414,
		[
			73414
		]
	],
	"./AllTickets": [
		99769,
		[
			22699,
			83096,
			88172,
			74155,
			1354,
			93814,
			94927,
			51883,
			87140,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			29061,
			35645,
			23206,
			90179,
			45595,
			98876,
			38639
		]
	],
	"./AllTickets.jsx": [
		99769,
		[
			22699,
			83096,
			88172,
			74155,
			1354,
			93814,
			94927,
			51883,
			87140,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			29061,
			35645,
			23206,
			90179,
			45595,
			98876,
			38639
		]
	],
	"./Allocation": [
		5724,
		[
			83343
		]
	],
	"./Allocation.jsx": [
		5724,
		[
			83343
		]
	],
	"./AllopathyDoctorDashboard": [
		80544,
		[
			22699,
			27045,
			9076,
			87257,
			80544
		]
	],
	"./AllopathyDoctorDashboard.jsx": [
		80544,
		[
			22699,
			27045,
			9076,
			87257,
			80544
		]
	],
	"./ApprovePrescription": [
		77386,
		[
			74155,
			1354,
			60426,
			84612,
			91719,
			72776
		]
	],
	"./ApprovePrescription.jsx": [
		77386,
		[
			74155,
			1354,
			60426,
			84612,
			91719,
			72776
		]
	],
	"./ApprovePrescription/": [
		91719,
		[
			74155,
			1354,
			60426,
			84612,
			91719,
			11863
		]
	],
	"./ApprovePrescription/components/AddMedicineModal": [
		96704,
		[
			96704
		]
	],
	"./ApprovePrescription/components/AddMedicineModal.jsx": [
		96704,
		[
			96704
		]
	],
	"./ApprovePrescription/components/ApprovalModal": [
		70154,
		[
			70154
		]
	],
	"./ApprovePrescription/components/ApprovalModal.jsx": [
		70154,
		[
			70154
		]
	],
	"./ApprovePrescription/components/ChangeTracker": [
		42330,
		[
			42330
		]
	],
	"./ApprovePrescription/components/ChangeTracker.jsx": [
		42330,
		[
			42330
		]
	],
	"./ApprovePrescription/components/PrescriptionCard": [
		13278,
		[
			13278
		]
	],
	"./ApprovePrescription/components/PrescriptionCard.jsx": [
		13278,
		[
			13278
		]
	],
	"./ApprovePrescription/components/PrescriptionDetails": [
		84612,
		[
			84612,
			34244
		]
	],
	"./ApprovePrescription/components/PrescriptionDetails.jsx": [
		84612,
		[
			84612,
			34244
		]
	],
	"./ApprovePrescription/components/PrescriptionFilters": [
		60835,
		[
			74155,
			1354,
			60835
		]
	],
	"./ApprovePrescription/components/PrescriptionFilters.jsx": [
		60835,
		[
			74155,
			1354,
			60835
		]
	],
	"./ApprovePrescription/components/PrescriptionList": [
		47772,
		[
			47772
		]
	],
	"./ApprovePrescription/components/PrescriptionList.jsx": [
		47772,
		[
			47772
		]
	],
	"./ApprovePrescription/components/PrescriptionStatistics": [
		21057,
		[
			74155,
			1354,
			60426,
			21057
		]
	],
	"./ApprovePrescription/components/PrescriptionStatistics.jsx": [
		21057,
		[
			74155,
			1354,
			60426,
			21057
		]
	],
	"./ApprovePrescription/components/PrescriptionTabs": [
		50223,
		[
			72604
		]
	],
	"./ApprovePrescription/components/PrescriptionTabs.jsx": [
		50223,
		[
			72604
		]
	],
	"./ApprovePrescription/components/RejectionModal": [
		57600,
		[
			57600
		]
	],
	"./ApprovePrescription/components/RejectionModal.jsx": [
		57600,
		[
			57600
		]
	],
	"./ApprovePrescription/index": [
		91719,
		[
			74155,
			1354,
			60426,
			84612,
			91719,
			11863
		]
	],
	"./ApprovePrescription/index.jsx": [
		91719,
		[
			74155,
			1354,
			60426,
			84612,
			91719,
			11863
		]
	],
	"./AssignedDoctors": [
		97017,
		[
			22699,
			83096,
			88172,
			97017
		]
	],
	"./AssignedDoctors.jsx": [
		97017,
		[
			22699,
			83096,
			88172,
			97017
		]
	],
	"./AssignedTickets": [
		35870,
		[
			22699,
			83096,
			88172,
			74155,
			1354,
			93814,
			94927,
			51883,
			87140,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			29061,
			35645,
			23206,
			90179,
			45595,
			98876,
			14152
		]
	],
	"./AssignedTickets.jsx": [
		35870,
		[
			22699,
			83096,
			88172,
			74155,
			1354,
			93814,
			94927,
			51883,
			87140,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			29061,
			35645,
			23206,
			90179,
			45595,
			98876,
			14152
		]
	],
	"./BarGraph": [
		37008,
		[
			89264,
			15082,
			39247,
			99407,
			83384,
			78766,
			37008
		]
	],
	"./BarGraph.jsx": [
		37008,
		[
			89264,
			15082,
			39247,
			99407,
			83384,
			78766,
			37008
		]
	],
	"./BarGraphColumn": [
		57657,
		[
			89264,
			15082,
			39247,
			80038
		]
	],
	"./BarGraphColumn.jsx": [
		57657,
		[
			89264,
			15082,
			39247,
			80038
		]
	],
	"./BulkDeactivate": [
		91523,
		[
			91523
		]
	],
	"./BulkDeactivate.jsx": [
		91523,
		[
			91523
		]
	],
	"./CalendarComponent": [
		85046,
		[
			94927,
			28360,
			85046
		]
	],
	"./CalendarComponent.jsx": [
		85046,
		[
			94927,
			28360,
			85046
		]
	],
	"./CallDashboard": [
		4485,
		[
			74155,
			1354,
			4485
		]
	],
	"./CallDashboard.jsx": [
		4485,
		[
			74155,
			1354,
			4485
		]
	],
	"./CallStats": [
		25884,
		[
			22699,
			27045,
			89264,
			15082,
			39247,
			87257,
			35645,
			25884
		]
	],
	"./CallStats.jsx": [
		25884,
		[
			22699,
			27045,
			89264,
			15082,
			39247,
			87257,
			35645,
			25884
		]
	],
	"./CheckoutSuccessRatePage": [
		55647,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			55647
		]
	],
	"./CheckoutSuccessRatePage.jsx": [
		55647,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			55647
		]
	],
	"./ClinicManagement": [
		50688,
		[
			22699,
			83096,
			88172,
			27045,
			74155,
			1354,
			47975,
			93814,
			46051,
			94927,
			51883,
			87140,
			12067,
			88007,
			9076,
			6531,
			65489,
			31041,
			90520,
			60005,
			95833,
			63428,
			2605,
			28360,
			28878,
			38273,
			34150,
			16274,
			19181,
			23206,
			1506,
			36209,
			64753,
			44572,
			68400,
			45142,
			89986,
			61705,
			37485,
			41367,
			8363,
			71073
		]
	],
	"./ClinicManagement.jsx": [
		50688,
		[
			22699,
			83096,
			88172,
			27045,
			74155,
			1354,
			47975,
			93814,
			46051,
			94927,
			51883,
			87140,
			12067,
			88007,
			9076,
			6531,
			65489,
			31041,
			90520,
			60005,
			95833,
			63428,
			2605,
			28360,
			28878,
			38273,
			34150,
			16274,
			19181,
			23206,
			1506,
			36209,
			64753,
			44572,
			68400,
			45142,
			89986,
			61705,
			37485,
			41367,
			8363,
			71073
		]
	],
	"./CodToPrepaid": [
		50972,
		[
			22699,
			83096,
			88172,
			40037,
			28591
		]
	],
	"./CodToPrepaid.jsx": [
		50972,
		[
			22699,
			83096,
			88172,
			40037,
			28591
		]
	],
	"./Community": [
		20262,
		[
			22699,
			27045,
			74155,
			1354,
			47975,
			46051,
			55924,
			35645,
			20262
		]
	],
	"./Community.jsx": [
		20262,
		[
			22699,
			27045,
			74155,
			1354,
			47975,
			46051,
			55924,
			35645,
			20262
		]
	],
	"./CommunityEngagements": [
		46112,
		[
			74155,
			1354,
			35645,
			46112
		]
	],
	"./CommunityEngagements.jsx": [
		46112,
		[
			74155,
			1354,
			35645,
			46112
		]
	],
	"./ConsultationInvoices": [
		89442,
		[
			74155,
			1354,
			89442
		]
	],
	"./ConsultationInvoices.jsx": [
		89442,
		[
			74155,
			1354,
			89442
		]
	],
	"./ControlTower": [
		23454,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			45627,
			49796,
			70968,
			65774,
			82549,
			61543,
			61382,
			80281,
			96362,
			39070,
			65306,
			29878,
			23454
		]
	],
	"./ControlTower/": [
		23454,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			45627,
			49796,
			70968,
			65774,
			82549,
			61543,
			61382,
			80281,
			96362,
			39070,
			65306,
			29878,
			23454
		]
	],
	"./ControlTower/ContentArea": [
		65306,
		[
			89264,
			49796,
			65774,
			82549,
			61543,
			65306,
			41271
		]
	],
	"./ControlTower/ContentArea.jsx": [
		65306,
		[
			89264,
			49796,
			65774,
			82549,
			61543,
			65306,
			41271
		]
	],
	"./ControlTower/DrilldownModal": [
		65774,
		[
			65774
		]
	],
	"./ControlTower/DrilldownModal.jsx": [
		65774,
		[
			65774
		]
	],
	"./ControlTower/ManifestedPickedContent": [
		52369,
		[
			65774,
			82549,
			54503
		]
	],
	"./ControlTower/ManifestedPickedContent.jsx": [
		52369,
		[
			65774,
			82549,
			54503
		]
	],
	"./ControlTower/MustDeliverStuckContent": [
		95831,
		[
			95831
		]
	],
	"./ControlTower/MustDeliverStuckContent.jsx": [
		95831,
		[
			95831
		]
	],
	"./ControlTower/OverviewContent": [
		29878,
		[
			65774,
			82549,
			29878,
			51022
		]
	],
	"./ControlTower/OverviewContent.jsx": [
		29878,
		[
			65774,
			82549,
			29878,
			51022
		]
	],
	"./ControlTower/PincodePerformanceContent": [
		80281,
		[
			74155,
			1354,
			45627,
			65774,
			82549,
			80281
		]
	],
	"./ControlTower/PincodePerformanceContent.jsx": [
		80281,
		[
			74155,
			1354,
			45627,
			65774,
			82549,
			80281
		]
	],
	"./ControlTower/RTOAnalyzerContent": [
		39070,
		[
			74155,
			1354,
			65774,
			82549,
			39070,
			10604
		]
	],
	"./ControlTower/RTOAnalyzerContent.jsx": [
		39070,
		[
			74155,
			1354,
			65774,
			82549,
			39070,
			10604
		]
	],
	"./ControlTower/RadReportContent": [
		61382,
		[
			89264,
			15082,
			99407,
			32455,
			83384,
			26914,
			65774,
			82549,
			61382,
			90963
		]
	],
	"./ControlTower/RadReportContent.jsx": [
		61382,
		[
			89264,
			15082,
			99407,
			32455,
			83384,
			26914,
			65774,
			82549,
			61382,
			90963
		]
	],
	"./ControlTower/StuckOrdersContent": [
		96362,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			65774,
			82549,
			96362,
			58692
		]
	],
	"./ControlTower/StuckOrdersContent.jsx": [
		96362,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			65774,
			82549,
			96362,
			58692
		]
	],
	"./ControlTower/ZoneAnalysisContent": [
		67925,
		[
			74155,
			1354,
			65774,
			82549,
			74693
		]
	],
	"./ControlTower/ZoneAnalysisContent.jsx": [
		67925,
		[
			74155,
			1354,
			65774,
			82549,
			74693
		]
	],
	"./ControlTower/charts": [
		61543,
		[
			89264,
			61543,
			48830
		]
	],
	"./ControlTower/charts.jsx": [
		61543,
		[
			89264,
			61543,
			48830
		]
	],
	"./ControlTower/constants": [
		7841,
		[
			7841
		]
	],
	"./ControlTower/constants.jsx": [
		7841,
		[
			7841
		]
	],
	"./ControlTower/index": [
		23454,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			45627,
			49796,
			70968,
			65774,
			82549,
			61543,
			61382,
			80281,
			96362,
			39070,
			65306,
			29878,
			23454
		]
	],
	"./ControlTower/index.jsx": [
		23454,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			45627,
			49796,
			70968,
			65774,
			82549,
			61543,
			61382,
			80281,
			96362,
			39070,
			65306,
			29878,
			23454
		]
	],
	"./ControlTower/insights": [
		75201,
		[
			75201
		]
	],
	"./ControlTower/insights.js": [
		75201,
		[
			75201
		]
	],
	"./ControlTower/ui-components": [
		82549,
		[
			65774,
			82549,
			58305
		]
	],
	"./ControlTower/ui-components.jsx": [
		82549,
		[
			65774,
			82549,
			58305
		]
	],
	"./CreateCategory": [
		91293,
		[
			3393,
			35645,
			91293
		]
	],
	"./CreateCategory.jsx": [
		91293,
		[
			3393,
			35645,
			91293
		]
	],
	"./CustomerChat": [
		20863,
		[
			22699,
			83096,
			88172,
			89439,
			39209
		]
	],
	"./CustomerChat.jsx": [
		20863,
		[
			22699,
			83096,
			88172,
			89439,
			39209
		]
	],
	"./CustomerComputedDataPage": [
		59581,
		[
			66445,
			59581
		]
	],
	"./CustomerComputedDataPage.jsx": [
		59581,
		[
			66445,
			59581
		]
	],
	"./CustomerDataPage": [
		49220,
		[
			66445,
			50642,
			49220
		]
	],
	"./CustomerDataPage.jsx": [
		49220,
		[
			66445,
			50642,
			49220
		]
	],
	"./CustomerFeedback": [
		69080,
		[
			22699,
			83096,
			88172,
			27045,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			87257,
			26914,
			19505,
			65181,
			90796,
			33129,
			48798
		]
	],
	"./CustomerFeedback.jsx": [
		69080,
		[
			22699,
			83096,
			88172,
			27045,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			87257,
			26914,
			19505,
			65181,
			90796,
			33129,
			48798
		]
	],
	"./DailyPendencyPage": [
		89313,
		[
			89313
		]
	],
	"./DailyPendencyPage.jsx": [
		89313,
		[
			89313
		]
	],
	"./DashboardHome": [
		77708,
		[
			77708
		]
	],
	"./DashboardHome.jsx": [
		77708,
		[
			77708
		]
	],
	"./DelayedComm": [
		54215,
		[
			74155,
			1354,
			54215
		]
	],
	"./DelayedComm.jsx": [
		54215,
		[
			74155,
			1354,
			54215
		]
	],
	"./DiscountCodes": [
		2252,
		[
			2252
		]
	],
	"./DiscountCodes.jsx": [
		2252,
		[
			2252
		]
	],
	"./DoctorBooking": [
		722,
		[
			22699,
			27045,
			87257,
			84277,
			35645,
			12467,
			14320,
			97260
		]
	],
	"./DoctorBooking/": [
		722,
		[
			22699,
			27045,
			87257,
			84277,
			35645,
			12467,
			14320,
			97260
		]
	],
	"./DoctorBooking/DoctorBooking": [
		14320,
		[
			22699,
			27045,
			87257,
			84277,
			35645,
			12467,
			14320,
			7975
		]
	],
	"./DoctorBooking/DoctorBooking.jsx": [
		14320,
		[
			22699,
			27045,
			87257,
			84277,
			35645,
			12467,
			14320,
			7975
		]
	],
	"./DoctorBooking/components/BookingStatsSidebar": [
		2135,
		[
			22699,
			27045,
			87257,
			84277,
			35645,
			2135
		]
	],
	"./DoctorBooking/components/BookingStatsSidebar.jsx": [
		2135,
		[
			22699,
			27045,
			87257,
			84277,
			35645,
			2135
		]
	],
	"./DoctorBooking/components/BookingTabs": [
		68000,
		[
			68000
		]
	],
	"./DoctorBooking/components/BookingTabs.jsx": [
		68000,
		[
			68000
		]
	],
	"./DoctorBooking/components/CallDetails": [
		12467,
		[
			12467,
			58710
		]
	],
	"./DoctorBooking/components/CallDetails.jsx": [
		12467,
		[
			12467,
			58710
		]
	],
	"./DoctorBooking/components/CallList": [
		38797,
		[
			61178
		]
	],
	"./DoctorBooking/components/CallList.jsx": [
		38797,
		[
			61178
		]
	],
	"./DoctorBooking/index": [
		722,
		[
			22699,
			27045,
			87257,
			84277,
			35645,
			12467,
			14320,
			97260
		]
	],
	"./DoctorBooking/index.js": [
		722,
		[
			22699,
			27045,
			87257,
			84277,
			35645,
			12467,
			14320,
			97260
		]
	],
	"./DoctorConsultationRefund": [
		91161,
		[
			74155,
			1354,
			93814,
			94927,
			51883,
			12067,
			23206,
			50587,
			99983
		]
	],
	"./DoctorConsultationRefund.jsx": [
		91161,
		[
			74155,
			1354,
			93814,
			94927,
			51883,
			12067,
			23206,
			50587,
			99983
		]
	],
	"./DoctorsDashboard": [
		22485,
		[
			22699,
			83096,
			88172,
			27045,
			87257,
			22485
		]
	],
	"./DoctorsDashboard.jsx": [
		22485,
		[
			22699,
			83096,
			88172,
			27045,
			87257,
			22485
		]
	],
	"./DraftLeadUserComponent": [
		13626,
		[
			13626
		]
	],
	"./DraftLeadUserComponent.jsx": [
		13626,
		[
			13626
		]
	],
	"./Engagement": [
		50908,
		[
			22699,
			27045,
			87257,
			50908
		]
	],
	"./Engagement.jsx": [
		50908,
		[
			22699,
			27045,
			87257,
			50908
		]
	],
	"./EngagementDetailsPage": [
		99529,
		[
			74155,
			1354,
			99529
		]
	],
	"./EngagementDetailsPage.jsx": [
		99529,
		[
			74155,
			1354,
			99529
		]
	],
	"./EngagementRep": [
		76007,
		[
			22699,
			83096,
			88172,
			74155,
			1354,
			87140,
			78292,
			25432,
			76074,
			95521
		]
	],
	"./EngagementRep.jsx": [
		76007,
		[
			22699,
			83096,
			88172,
			74155,
			1354,
			87140,
			78292,
			25432,
			76074,
			95521
		]
	],
	"./EngagementReports": [
		12283,
		[
			22699,
			83096,
			88172,
			27045,
			47975,
			46051,
			87140,
			87257,
			10699,
			12283
		]
	],
	"./EngagementReports.jsx": [
		12283,
		[
			22699,
			83096,
			88172,
			27045,
			47975,
			46051,
			87140,
			87257,
			10699,
			12283
		]
	],
	"./EngagementStats": [
		43679,
		[
			22699,
			83096,
			88172,
			27045,
			87140,
			87257,
			43679
		]
	],
	"./EngagementStats.jsx": [
		43679,
		[
			22699,
			83096,
			88172,
			27045,
			87140,
			87257,
			43679
		]
	],
	"./EngagementSummary": [
		91374,
		[
			22699,
			83096,
			88172,
			27045,
			87140,
			87257,
			94471,
			91374
		]
	],
	"./EngagementSummary.jsx": [
		91374,
		[
			22699,
			83096,
			88172,
			27045,
			87140,
			87257,
			94471,
			91374
		]
	],
	"./EngagementV2": [
		9200,
		[
			22699,
			27045,
			87257,
			35645,
			9200
		]
	],
	"./EngagementV2.jsx": [
		9200,
		[
			22699,
			27045,
			87257,
			35645,
			9200
		]
	],
	"./EngagementView": [
		53831,
		[
			53831
		]
	],
	"./EngagementView.jsx": [
		53831,
		[
			53831
		]
	],
	"./Escalation": [
		98782,
		[
			98782
		]
	],
	"./Escalation.jsx": [
		98782,
		[
			98782
		]
	],
	"./FinanceDashboard": [
		82599,
		[
			22699,
			27045,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			82599
		]
	],
	"./FinanceDashboard.jsx": [
		82599,
		[
			22699,
			27045,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			82599
		]
	],
	"./GhostOrders": [
		35975,
		[
			22699,
			83096,
			88172,
			91990,
			35975
		]
	],
	"./GhostOrders.jsx": [
		35975,
		[
			22699,
			83096,
			88172,
			91990,
			35975
		]
	],
	"./GroupManagement": [
		13353,
		[
			22699,
			83096,
			88172,
			93814,
			76213,
			92162,
			33823
		]
	],
	"./GroupManagement.jsx": [
		13353,
		[
			22699,
			83096,
			88172,
			93814,
			76213,
			92162,
			33823
		]
	],
	"./Home": [
		69744,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			28869,
			48876,
			93656
		]
	],
	"./Home.jsx": [
		69744,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			28869,
			48876,
			93656
		]
	],
	"./InternalTickets": [
		74415,
		[
			22699,
			83096,
			88172,
			74155,
			1354,
			93814,
			94927,
			51883,
			87140,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			29061,
			35645,
			23206,
			90179,
			45595,
			98876,
			51865
		]
	],
	"./InternalTickets.jsx": [
		74415,
		[
			22699,
			83096,
			88172,
			74155,
			1354,
			93814,
			94927,
			51883,
			87140,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			29061,
			35645,
			23206,
			90179,
			45595,
			98876,
			51865
		]
	],
	"./InventoryTracker": [
		53737,
		[
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			83529,
			53737
		]
	],
	"./InventoryTracker.jsx": [
		53737,
		[
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			83529,
			53737
		]
	],
	"./InvoiceGenerate": [
		62701,
		[
			22699,
			83096,
			88172,
			27045,
			87257,
			7413,
			26227
		]
	],
	"./InvoiceGenerate.jsx": [
		62701,
		[
			22699,
			83096,
			88172,
			27045,
			87257,
			7413,
			26227
		]
	],
	"./IvrCall": [
		74312,
		[
			22699,
			27045,
			87257,
			74312
		]
	],
	"./IvrCall.jsx": [
		74312,
		[
			22699,
			27045,
			87257,
			74312
		]
	],
	"./LatestOrder": [
		60174,
		[
			60174
		]
	],
	"./LatestOrder.jsx": [
		60174,
		[
			60174
		]
	],
	"./ManageComponents": [
		19836,
		[
			19836
		]
	],
	"./ManageComponents.jsx": [
		19836,
		[
			19836
		]
	],
	"./ManageContents": [
		70058,
		[
			55738,
			31894,
			70058
		]
	],
	"./ManageContents.jsx": [
		70058,
		[
			55738,
			31894,
			70058
		]
	],
	"./ManageSegment": [
		91945,
		[
			89431,
			91945
		]
	],
	"./ManageSegment.jsx": [
		91945,
		[
			89431,
			91945
		]
	],
	"./ManageTag": [
		91070,
		[
			55565,
			91070
		]
	],
	"./ManageTag.jsx": [
		91070,
		[
			55565,
			91070
		]
	],
	"./ManageWeekly": [
		25201,
		[
			9076,
			25201
		]
	],
	"./ManageWeekly.jsx": [
		25201,
		[
			9076,
			25201
		]
	],
	"./MasterComponent": [
		55638,
		[
			47975,
			46051,
			59966
		]
	],
	"./MasterComponent.jsx": [
		55638,
		[
			47975,
			46051,
			59966
		]
	],
	"./Medicines": [
		50746,
		[
			77946,
			50746
		]
	],
	"./Medicines.jsx": [
		50746,
		[
			77946,
			50746
		]
	],
	"./MobileTaskList": [
		91601,
		[
			22699,
			83096,
			88172,
			47975,
			46051,
			35645,
			91601
		]
	],
	"./MobileTaskList.jsx": [
		91601,
		[
			22699,
			83096,
			88172,
			47975,
			46051,
			35645,
			91601
		]
	],
	"./MyAppointment": [
		67336,
		[
			22699,
			83096,
			88172,
			27045,
			87257,
			67336
		]
	],
	"./MyAppointment.jsx": [
		67336,
		[
			22699,
			83096,
			88172,
			27045,
			87257,
			67336
		]
	],
	"./MyTeam": [
		80692,
		[
			22699,
			83096,
			88172,
			35645,
			80692
		]
	],
	"./MyTeam.jsx": [
		80692,
		[
			22699,
			83096,
			88172,
			35645,
			80692
		]
	],
	"./MyTickets": [
		15562,
		[
			22699,
			83096,
			88172,
			27045,
			74155,
			1354,
			47975,
			93814,
			46051,
			94927,
			51883,
			87140,
			12067,
			88007,
			9076,
			6531,
			65489,
			31041,
			90520,
			60005,
			95833,
			63428,
			2605,
			89264,
			28360,
			28878,
			38273,
			15082,
			34150,
			39247,
			99407,
			83384,
			78766,
			87257,
			26914,
			19505,
			65181,
			90796,
			42573,
			19181,
			23206,
			1506,
			36209,
			64753,
			44572,
			68400,
			45142,
			89986,
			61705,
			37485,
			41367,
			80958,
			82881,
			77275,
			83427
		]
	],
	"./MyTickets.jsx": [
		15562,
		[
			22699,
			83096,
			88172,
			27045,
			74155,
			1354,
			47975,
			93814,
			46051,
			94927,
			51883,
			87140,
			12067,
			88007,
			9076,
			6531,
			65489,
			31041,
			90520,
			60005,
			95833,
			63428,
			2605,
			89264,
			28360,
			28878,
			38273,
			15082,
			34150,
			39247,
			99407,
			83384,
			78766,
			87257,
			26914,
			19505,
			65181,
			90796,
			42573,
			19181,
			23206,
			1506,
			36209,
			64753,
			44572,
			68400,
			45142,
			89986,
			61705,
			37485,
			41367,
			80958,
			82881,
			77275,
			83427
		]
	],
	"./NaNdrOrders": [
		80635,
		[
			80635
		]
	],
	"./NaNdrOrders.jsx": [
		80635,
		[
			80635
		]
	],
	"./NewSalesDashboard": [
		34187,
		[
			22699,
			27045,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			65181,
			34187
		]
	],
	"./NewSalesDashboard.jsx": [
		34187,
		[
			22699,
			27045,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			65181,
			34187
		]
	],
	"./NpsAnalysisDashboardPage": [
		42293,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			90054,
			42293
		]
	],
	"./NpsAnalysisDashboardPage.jsx": [
		42293,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			90054,
			42293
		]
	],
	"./NpsV2Page": [
		54697,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			90054,
			54697
		]
	],
	"./NpsV2Page.jsx": [
		54697,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			90054,
			54697
		]
	],
	"./OfflineBulkKitCohortConfig": [
		77635,
		[
			36272,
			75824,
			77635
		]
	],
	"./OfflineBulkKitCohortConfig.jsx": [
		77635,
		[
			36272,
			75824,
			77635
		]
	],
	"./OfflineDoctorRoaster": [
		60007,
		[
			60007
		]
	],
	"./OfflineDoctorRoaster.jsx": [
		60007,
		[
			60007
		]
	],
	"./OfflineHairTestConfig": [
		65562,
		[
			93814,
			63622,
			2510,
			35762
		]
	],
	"./OfflineHairTestConfig.jsx": [
		65562,
		[
			93814,
			63622,
			2510,
			35762
		]
	],
	"./OpenOrders": [
		6890,
		[
			22699,
			83096,
			88172,
			27045,
			6890
		]
	],
	"./OpenOrders.jsx": [
		6890,
		[
			22699,
			83096,
			88172,
			27045,
			6890
		]
	],
	"./OrderCaseDetails": [
		6739,
		[
			6739
		]
	],
	"./OrderCaseDetails.jsx": [
		6739,
		[
			6739
		]
	],
	"./OrderDashboard": [
		37581,
		[
			22699,
			27045,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			26914,
			104,
			37581
		]
	],
	"./OrderDashboard.jsx": [
		37581,
		[
			22699,
			27045,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			26914,
			104,
			37581
		]
	],
	"./OrderManagement": [
		9388,
		[
			22699,
			83096,
			88172,
			9388
		]
	],
	"./OrderManagement.jsx": [
		9388,
		[
			22699,
			83096,
			88172,
			9388
		]
	],
	"./OrderedUserComponent": [
		3654,
		[
			3654
		]
	],
	"./OrderedUserComponent.jsx": [
		3654,
		[
			3654
		]
	],
	"./OutboundSummaryPage": [
		60288,
		[
			60288
		]
	],
	"./OutboundSummaryPage.jsx": [
		60288,
		[
			60288
		]
	],
	"./PerformanceDashboard": [
		70391,
		[
			22699,
			27045,
			78292,
			70391
		]
	],
	"./PerformanceDashboard.jsx": [
		70391,
		[
			22699,
			27045,
			78292,
			70391
		]
	],
	"./PostSalesDashboard": [
		32591,
		[
			22699,
			83096,
			88172,
			27045,
			47975,
			46051,
			96365,
			32591,
			35409
		]
	],
	"./PostSalesDashboard.jsx": [
		32591,
		[
			22699,
			83096,
			88172,
			27045,
			47975,
			46051,
			96365,
			32591,
			35409
		]
	],
	"./PreDispatchCodToPrepaid": [
		82358,
		[
			74155,
			1354,
			60005,
			82358
		]
	],
	"./PreDispatchCodToPrepaid.jsx": [
		82358,
		[
			74155,
			1354,
			60005,
			82358
		]
	],
	"./PrescribedPatients": [
		5532,
		[
			22699,
			27045,
			9076,
			87257,
			35645,
			5532
		]
	],
	"./PrescribedPatients.jsx": [
		5532,
		[
			22699,
			27045,
			9076,
			87257,
			35645,
			5532
		]
	],
	"./ProductManagement": [
		62277,
		[
			36397,
			12108,
			1888,
			31056,
			82643
		]
	],
	"./ProductManagement.jsx": [
		62277,
		[
			36397,
			12108,
			1888,
			31056,
			82643
		]
	],
	"./ProductMapping": [
		66124,
		[
			97164,
			66124
		]
	],
	"./ProductMapping.jsx": [
		66124,
		[
			97164,
			66124
		]
	],
	"./RBACConfigure": [
		98553,
		[
			67000,
			50509,
			23507,
			78292,
			67896,
			24911,
			96968
		]
	],
	"./RBACConfigure.jsx": [
		98553,
		[
			67000,
			50509,
			23507,
			78292,
			67896,
			24911,
			96968
		]
	],
	"./RecentOrders": [
		12395,
		[
			22699,
			83096,
			88172,
			93366,
			12395
		]
	],
	"./RecentOrders.jsx": [
		12395,
		[
			22699,
			83096,
			88172,
			93366,
			12395
		]
	],
	"./RecentTransfer": [
		1073,
		[
			1073
		]
	],
	"./RecentTransfer.jsx": [
		1073,
		[
			1073
		]
	],
	"./RefundTracking": [
		22088,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			22088
		]
	],
	"./RefundTracking.jsx": [
		22088,
		[
			74155,
			1354,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			22088
		]
	],
	"./Reports": [
		87652,
		[
			22699,
			27045,
			87652
		]
	],
	"./Reports.jsx": [
		87652,
		[
			22699,
			27045,
			87652
		]
	],
	"./RevenueTracker": [
		99565,
		[
			22699,
			27045,
			93814,
			63428,
			33265,
			35645,
			99565
		]
	],
	"./RevenueTracker.jsx": [
		99565,
		[
			22699,
			27045,
			93814,
			63428,
			33265,
			35645,
			99565
		]
	],
	"./RewardsPoints": [
		24604,
		[
			22699,
			83096,
			88172,
			94927,
			28360,
			24604
		]
	],
	"./RewardsPoints.jsx": [
		24604,
		[
			22699,
			83096,
			88172,
			94927,
			28360,
			24604
		]
	],
	"./SalesDashboard": [
		75693,
		[
			22699,
			27045,
			93814,
			35645,
			75693,
			74102
		]
	],
	"./SalesDashboard.jsx": [
		75693,
		[
			22699,
			27045,
			93814,
			35645,
			75693,
			74102
		]
	],
	"./Settings": [
		68446,
		[
			16274,
			77701
		]
	],
	"./Settings.jsx": [
		68446,
		[
			16274,
			77701
		]
	],
	"./SlotBookingLoggers": [
		82277,
		[
			22699,
			83096,
			88172,
			27045,
			87257,
			82277
		]
	],
	"./SlotBookingLoggers.jsx": [
		82277,
		[
			22699,
			83096,
			88172,
			27045,
			87257,
			82277
		]
	],
	"./SlotPendencyPage": [
		92866,
		[
			94303,
			92866
		]
	],
	"./SlotPendencyPage.jsx": [
		92866,
		[
			94303,
			92866
		]
	],
	"./Stats": [
		39708,
		[
			22699,
			83096,
			88172,
			27045,
			87140,
			87257,
			39708
		]
	],
	"./Stats.jsx": [
		39708,
		[
			22699,
			83096,
			88172,
			27045,
			87140,
			87257,
			39708
		]
	],
	"./StickyTaskList": [
		88599,
		[
			47975,
			46051,
			82361
		]
	],
	"./StickyTaskList.jsx": [
		88599,
		[
			47975,
			46051,
			82361
		]
	],
	"./StoreVisit": [
		53617,
		[
			74155,
			1354,
			93814,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			85159,
			16213,
			35645,
			34628,
			53617
		]
	],
	"./StoreVisit.jsx": [
		53617,
		[
			74155,
			1354,
			93814,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			85159,
			16213,
			35645,
			34628,
			53617
		]
	],
	"./SubscriptionAnalytics": [
		45080,
		[
			74155,
			1354,
			95833,
			55763,
			45080
		]
	],
	"./SubscriptionAnalytics.jsx": [
		45080,
		[
			74155,
			1354,
			95833,
			55763,
			45080
		]
	],
	"./SupportFeedback": [
		94445,
		[
			94445
		]
	],
	"./SupportFeedback.jsx": [
		94445,
		[
			94445
		]
	],
	"./TabTaskList": [
		25881,
		[
			47975,
			46051,
			48877
		]
	],
	"./TabTaskList.jsx": [
		25881,
		[
			47975,
			46051,
			48877
		]
	],
	"./Tags": [
		90170,
		[
			90170
		]
	],
	"./Tags.jsx": [
		90170,
		[
			90170
		]
	],
	"./TaskComponent": [
		78801,
		[
			78801
		]
	],
	"./TaskComponent.jsx": [
		78801,
		[
			78801
		]
	],
	"./TaskList": [
		96355,
		[
			22699,
			83096,
			88172,
			47975,
			46051,
			35645,
			96355
		]
	],
	"./TaskList.jsx": [
		96355,
		[
			22699,
			83096,
			88172,
			47975,
			46051,
			35645,
			96355
		]
	],
	"./TicketConfigure": [
		71361,
		[
			3393,
			35645,
			91293,
			71361
		]
	],
	"./TicketConfigure.jsx": [
		71361,
		[
			3393,
			35645,
			91293,
			71361
		]
	],
	"./TicketGroups": [
		79277,
		[
			35645,
			79277
		]
	],
	"./TicketGroups.jsx": [
		79277,
		[
			35645,
			79277
		]
	],
	"./TicketTabs": [
		82881,
		[
			22699,
			83096,
			88172,
			74155,
			1354,
			93814,
			94927,
			51883,
			12067,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			23206,
			90179,
			82881,
			57917
		]
	],
	"./TicketTabs.jsx": [
		82881,
		[
			22699,
			83096,
			88172,
			74155,
			1354,
			93814,
			94927,
			51883,
			12067,
			89264,
			15082,
			39247,
			99407,
			32455,
			83384,
			78766,
			26914,
			19505,
			65181,
			90796,
			23206,
			90179,
			82881,
			57917
		]
	],
	"./TicketingSettings": [
		18154,
		[
			3393,
			35645,
			91293,
			18154
		]
	],
	"./TicketingSettings.jsx": [
		18154,
		[
			3393,
			35645,
			91293,
			18154
		]
	],
	"./TransferCustomerUpload": [
		92267,
		[
			92267
		]
	],
	"./TransferCustomerUpload.jsx": [
		92267,
		[
			92267
		]
	],
	"./UnshippedOrders": [
		21372,
		[
			21372
		]
	],
	"./UnshippedOrders.jsx": [
		21372,
		[
			21372
		]
	],
	"./UpdateOrders": [
		64833,
		[
			64833
		]
	],
	"./UpdateOrders.jsx": [
		64833,
		[
			64833
		]
	],
	"./UpdateOrdersHistory": [
		37449,
		[
			37449
		]
	],
	"./UpdateOrdersHistory.jsx": [
		37449,
		[
			37449
		]
	],
	"./UserComponent": [
		74895,
		[
			74895
		]
	],
	"./UserComponent.jsx": [
		74895,
		[
			74895
		]
	],
	"./UtmCampaign": [
		86807,
		[
			22699,
			27045,
			86807
		]
	],
	"./UtmCampaign.jsx": [
		86807,
		[
			22699,
			27045,
			86807
		]
	],
	"./Warehouse": [
		47500,
		[
			22699,
			74155,
			1354,
			47975,
			5246,
			59517,
			35645,
			79507,
			47500
		]
	],
	"./Warehouse.jsx": [
		47500,
		[
			22699,
			74155,
			1354,
			47975,
			5246,
			59517,
			35645,
			79507,
			47500
		]
	],
	"./WarehousePincodeMapping": [
		53684,
		[
			53684
		]
	],
	"./WarehousePincodeMapping.jsx": [
		53684,
		[
			53684
		]
	],
	"./WarehouseReport": [
		29518,
		[
			22699,
			74155,
			1354,
			47975,
			5246,
			59517,
			35645,
			29518
		]
	],
	"./WarehouseReport.jsx": [
		29518,
		[
			22699,
			74155,
			1354,
			47975,
			5246,
			59517,
			35645,
			29518
		]
	],
	"./Welcome": [
		47349,
		[]
	],
	"./Welcome.jsx": [
		47349,
		[]
	],
	"./WhatsAppAnalytics": [
		57599,
		[
			74155,
			1354,
			58938,
			49897,
			34332,
			57599
		]
	],
	"./WhatsAppAnalytics.jsx": [
		57599,
		[
			74155,
			1354,
			58938,
			49897,
			34332,
			57599
		]
	],
	"./WhatsAppAnalyticsComparison": [
		77320,
		[
			74155,
			1354,
			77320
		]
	],
	"./WhatsAppAnalyticsComparison.jsx": [
		77320,
		[
			74155,
			1354,
			77320
		]
	],
	"./WhatsAppAnalyticsDashboard": [
		56847,
		[
			58938,
			56847
		]
	],
	"./WhatsAppAnalyticsDashboard.jsx": [
		56847,
		[
			58938,
			56847
		]
	],
	"./WhatsAppTemplateInsights": [
		56958,
		[
			74155,
			1354,
			56958
		]
	],
	"./WhatsAppTemplateInsights.jsx": [
		56958,
		[
			74155,
			1354,
			56958
		]
	],
	"./WhatsAppTemplateManagement": [
		34332,
		[
			34332,
			3055
		]
	],
	"./WhatsAppTemplateManagement.jsx": [
		34332,
		[
			34332,
			3055
		]
	],
	"./api": [
		23932,
		[
			23932
		]
	],
	"./api/": [
		23932,
		[
			23932
		]
	],
	"./api/index": [
		23932,
		[
			23932
		]
	],
	"./api/index.js": [
		23932,
		[
			23932
		]
	],
	"./dispatchDashboard/DashboardDispatch": [
		25952,
		[
			35645,
			25952
		]
	],
	"./dispatchDashboard/DashboardDispatch.jsx": [
		25952,
		[
			35645,
			25952
		]
	],
	"./dispatchSearch/DispatchSearch": [
		9034,
		[
			35645,
			9034
		]
	],
	"./dispatchSearch/DispatchSearch.jsx": [
		9034,
		[
			35645,
			9034
		]
	],
	"./dispatchSearch/PickupList": [
		88944,
		[
			88944
		]
	],
	"./dispatchSearch/PickupList.jsx": [
		88944,
		[
			88944
		]
	],
	"./dispatchSearch/PlainPrint": [
		93093,
		[
			93093
		]
	],
	"./dispatchSearch/PlainPrint.jsx": [
		93093,
		[
			93093
		]
	],
	"./dispatchSearch/PrescriptionOrder": [
		91746,
		[
			35645,
			91746
		]
	],
	"./dispatchSearch/PrescriptionOrder.jsx": [
		91746,
		[
			35645,
			91746
		]
	],
	"./dispatchSearch/Print": [
		9527,
		[
			9527
		]
	],
	"./dispatchSearch/Print.jsx": [
		9527,
		[
			9527
		]
	],
	"./dispatchSearch/Search": [
		35928,
		[
			35645,
			35928
		]
	],
	"./dispatchSearch/Search.jsx": [
		35928,
		[
			35645,
			35928
		]
	],
	"./leadCallReport": [
		67633,
		[
			74155,
			1354,
			67633
		]
	],
	"./leadCallReport.jsx": [
		67633,
		[
			74155,
			1354,
			67633
		]
	],
	"./oda/components/ODA": [
		72103,
		[
			22699,
			27045,
			89727,
			50238,
			8957,
			72103
		]
	],
	"./oda/components/ODA.jsx": [
		72103,
		[
			22699,
			27045,
			89727,
			50238,
			8957,
			72103
		]
	],
	"./store": [
		35645,
		[
			35645
		]
	],
	"./store/": [
		35645,
		[
			35645
		]
	],
	"./store/index": [
		35645,
		[
			35645
		]
	],
	"./store/index.js": [
		35645,
		[
			35645
		]
	],
	"./webinar": [
		21615,
		[
			74155,
			1354,
			47975,
			46051,
			52695,
			35645,
			21615
		]
	],
	"./webinar.jsx": [
		21615,
		[
			74155,
			1354,
			47975,
			46051,
			52695,
			35645,
			21615
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 50629;
module.exports = webpackAsyncContext;